import { FC, PropsWithChildren, ReactElement } from "react";
import { Box, Dialog, DialogProps, IconButton, Stack } from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";

interface IModalProps {
  open: boolean;
  noPadding?: boolean;
  hideClose?: boolean;
  onClose?: () => void;
  sx?: DialogProps["sx"];
  maxWidth: "xs" | "sm" | "md" | "lg" | "xl";
}

const Modal: FC<PropsWithChildren<IModalProps>> = ({
  open,
  onClose,
  children,
  noPadding,
  maxWidth,
  hideClose,
  sx,
}): ReactElement => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={maxWidth}
      fullWidth
      sx={{
        ...sx,
        background: "rgba(97, 101, 106, 0.3)",
        ".MuiDialog-paper": {
          padding: noPadding ? "0rem" : "1.5rem",
          "::-webkit-scrollbar": { width: "0" },
        },
        div: {
          // borderRadius: "10px",
        },
      }}
    >
      {!hideClose && (
        <Stack justifyContent={"flex-end"} alignItems={"flex-end"}>
          <IconButton color="primary" onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Stack>
      )}
      <Box>{children}</Box>
    </Dialog>
  );
};

export default Modal;
